import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["type", "batch", "excel"]

  connect() {
    this.toggle()
  }

  toggle() {
    const commonReport = this.typeTarget.value === "relatorio"
    this.batchTarget.hidden = commonReport
    this.excelTarget.hidden = !commonReport
  }
}
